import { Avatar } from "components/core";
import { FC } from "react";
import { GetPromotion_getPromotion } from "_graphql/queries/__generated__/GetPromotion";
import _ from "lodash";
import clsx from "clsx";
import { format } from "date-fns";

type Props = {
  promotion: GetPromotion_getPromotion | null | undefined;
};

const PromotionAuditView: FC<Props> = ({ promotion }) => {
  const auditTrail = promotion?.auditTrail || [];

  if (auditTrail.length === 0) {
    return (
      <div className="text-center py-12">
        <div className="mx-auto h-12 w-12 text-gray-400">
          <svg
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
            />
          </svg>
        </div>
        <h3 className="mt-2 text-sm font-medium text-gray-900 dark:text-white">
          No audit trail
        </h3>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
          No activity has been recorded for this promotion yet.
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="border-b border-gray-200 dark:border-gray-700 pb-4">
        <h3 className="text-lg font-medium text-gray-900 dark:text-white">
          Activity Timeline
        </h3>
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
          Track all changes and activities for this promotion
        </p>
      </div>

      <div className="flow-root">
        <ul role="list" className="-mb-8">
          {auditTrail.map((activityItem, activityItemIdx) => (
            <li key={`${activityItem?.created_at}-${activityItemIdx}`}>
              <div className="relative pb-8">
                {activityItemIdx !== auditTrail.length - 1 ? (
                  <span
                    className="absolute left-4 top-4 -ml-px h-full w-0.5 bg-gray-200 dark:bg-gray-700"
                    aria-hidden="true"
                  />
                ) : null}
                <div className="relative flex space-x-3">
                  <div className="relative">
                    <div className="h-8 w-8 rounded-full bg-white dark:bg-gray-800 ring-2 ring-gray-300 dark:ring-gray-600 flex items-center justify-center">
                      <Avatar
                        alt={activityItem?.actor || "Unknown User"}
                        // className="h-6 w-6"
                      />
                    </div>
                  </div>
                  <div className="flex min-w-0 flex-1 justify-between space-x-4 pt-1.5">
                    <div className="min-w-0 flex-1">
                      <p className="text-sm text-gray-900 dark:text-white">
                        <span className="font-medium">
                          {activityItem?.actor || "Unknown User"}
                        </span>{" "}
                        <span className="text-gray-600 dark:text-gray-300">
                          {activityItem?.action || "performed an action"}
                        </span>
                      </p>
                      {/* {activityItem?.description && (
                        <div className="mt-2 text-sm text-gray-500 dark:text-gray-400">
                          <p>{activityItem.description}</p>
                        </div>
                      )} */}
                    </div>
                    <div className="whitespace-nowrap text-right text-sm text-gray-500 dark:text-gray-400">
                      <time dateTime={activityItem?.created_at}>
                        {activityItem?.created_at ? (
                          <>
                            <div className="font-medium">
                              {format(
                                new Date(activityItem.created_at),
                                "MMM d, yyyy"
                              )}
                            </div>
                            <div className="text-xs">
                              {format(
                                new Date(activityItem.created_at),
                                "h:mm a"
                              )}
                            </div>
                          </>
                        ) : (
                          "Unknown time"
                        )}
                      </time>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default PromotionAuditView;
